import { render, staticRenderFns } from "./AnalyticsPopularIngredients.vue?vue&type=template&id=a9f1e87c"
import script from "./AnalyticsPopularIngredients.vue?vue&type=script&lang=js"
export * from "./AnalyticsPopularIngredients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports